import dummy_vertex_shader from './dummy.vs';
import dummy_fragment_shader from './dummy.fs';

import general_vs from './pickers/general.vs';
import general_fs from './pickers/general.fs';

import cad_vs from './pickers/cad.vs';
import cad_fs from './pickers/cad.fs';

import potree_vs from './pickers/potree.vs';
import potree_fs from './pickers/potree.fs';

import potree_distance_picker_vs from './pickers/potree_picker.vs';
import potree_id_picker_fs from './pickers/potree_id_picker.fs';
import potree_distance_picker_fs from './pickers/potree_distance_picker.fs';

import picking_normal_vertex_shader from './picking-normal.vs';
import picking_normal_fragment_shader from './picking-normal.fs';

import freehand_draw_vertex_shader from './freehand-draw.vs';
import freehand_draw_fragment_shader from './freehand-draw.fs';

import iq3_model_standard_vertex_shader from './iq3-model-standard.vs';
import iq3_model_standard_fragment_shader from './iq3-model-standard.fs';

import cubemap_vertex_shader from './cubemap.vs';
import cubemap_fragment_shader from './cubemap.fs';
import dummy_mesh_vertex_shader from "./dummy-mesh-shader.vs";
import dummy_mesh_fragment_shader from "./dummy-mesh-shader.fs";

// globally used, hence need entry point before moving
// import text_vertex_shader from './text.vs';
// import text_fragment_shader from './text.fs';
// import text_hp_vertex_shader from './text-hp.vs';
// import text_hp_fragment_shader from './text-hp.fs';
// import text_ring_vertex_shader from './text-ring.vs';
// import text_ring_fragment_shader from './text-ring.fs';
// import glow_vertex_shader from './glow.vs';
// import glow_fragment_shader from './glow.fs';

export default {
    dummy_vertex_shader,
    dummy_fragment_shader,

    pickers: {
        general_vs: general_vs,
        general_fs: general_fs,

        cad_vs: cad_vs,
        cad_fs: cad_fs,

        potree_vs: potree_vs,
        potree_fs: potree_fs,

        potree_picker_vs: potree_distance_picker_vs,

        potree_id_picker_fs: potree_id_picker_fs,
        potree_distance_picker_fs: potree_distance_picker_fs,
    },

    picking_normal_vertex_shader,
    picking_normal_fragment_shader,

    freehand_draw_vertex_shader,
    freehand_draw_fragment_shader,

    iq3_model_standard_vertex_shader,
    iq3_model_standard_fragment_shader,

    cubemap_vertex_shader,
    cubemap_fragment_shader,
    dummy_mesh_vertex_shader,
    dummy_mesh_fragment_shader

    // globally used, hence need entry point before moving
    // text_vertex_shader,
    // text_fragment_shader,
    // text_hp_vertex_shader,
    // text_hp_fragment_shader,
    // text_ring_vertex_shader,
    // text_ring_fragment_shader,
    // glow_vertex_shader,
    // glow_fragment_shader
}
